//import {Howler, Howl} from '../../../node_modules/howler'

/**
 *  <Desription of Service here>
 *
 * @export
 * @class AudioManager
 */
export class AudioManager {

  /**
   * $inject to make angular DI minification safe
   *
   * @static
   * @type {Array<string>}
   */
  public static $inject: [string] = ['$log', 'LocalStorageManager'];
  public isMuted: boolean = false
  public settings: any
  public audioAssets: Array<IAudioAsset>
  public bgPlayer: any = undefined
  public fxPlayer: any = undefined
  /**
   * @param {$log} $log - Angular logging Service.
   */
  constructor(public $log: any, public LocalStorageManager: any) {
    this.$log = $log.getInstance('AudioManager', false);
    this.$log.debug('constructor');

    // check to see if user muted in a previous session
    if (this.LocalStorageManager.isSupported()) {
      if (this.LocalStorageManager.get('AUDIO_IS_MUTED_WW')) {
        this.isMuted = true;
        Howler.mute(true);
      } else {
        this.isMuted = false;
        Howler.mute(false);
      }
    } else {
      this.isMuted = false;
      Howler.mute(false);
    }

  }

  public init(config) {
    this.$log.debug('init', this)

    this.settings = config.settings.audio

    //get assets and setup paths
    this.audioAssets = config.audioAssets.map(asset => {
      asset.src = asset.src.map(url => {
        return this.settings.audioAssetsPath + url
      })
      return asset
    })

    //this.bgPlayer = new Howl(this.audioAssets)
    //this.fxPlayer = new Howl(this.audioAssets)

  }

  public playFx(key) {
    if (!this.settings.isAudioEnabled) {
      return
    }

    this.$log.debug("playFx", key)
    let asset: any = this.audioAssets.filter(this.findByKey, key)[0];
    if(this.fxPlayer){
      this.fxPlayer.stop();
    }

    this.fxPlayer = new Howl(asset)
  }

  public playBackgroundTrack(key) {
    if (!this.settings.isAudioEnabled) {
      return
    }

    this.$log.debug("playBackgroundTrack", key)
    let asset: any = this.audioAssets.filter(this.findByKey, key)[0];
    if(this.bgPlayer){
      this.bgPlayer.stop();
    }
    this.bgPlayer = new Howl(asset);
  }

  public findByKey(element, index, array) {
    return element.key === this;
  }

  public toggleSound() {
    this.$log.debug("toggleSound", this)

    if (!this.settings.isAudioEnabled) {
      return
    }

    if (!this.isMuted) {
      Howler.mute(true)
      this.bgPlayer.pause()
      this.isMuted = true
      if (this.LocalStorageManager.isSupported()) {
        this.LocalStorageManager.set('AUDIO_IS_MUTED_WW', true)
      }
    } else {
      Howler.mute(false)
      this.playBackgroundTrack(this.settings.initialBackgroundTrackKey)
      this.isMuted = false
      if (this.LocalStorageManager.isSupported()) {
        this.LocalStorageManager.set('AUDIO_IS_MUTED_WW', false)
      }
    };
  }

};



/** WEBPACK FOOTER **
 ** ./src/common/services/audio-manager/audio-manager.ts
 **/